export const analyticsDashboardAppGroupIdEmailEngagementByTimeData =
  "/analytics_dashboard/:app_group_id/email_engagement_by_time_data";
